import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { TrelloCheckItem } from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import { MatDialog } from '@angular/material/dialog';
import {
  TasksListDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/tasks-list-dialog/tasks-list-dialog.component';
import { OverlayPanel } from 'primeng/overlaypanel';
import * as jq from 'jquery';
import { TrelloService } from "../../../../../trello-misc/data/trello.service";
import { ProjectFile } from "../../../../data/project/project-file";
import { FileOpenerService } from '../../../../utils/fileOpener.service';
import { FileService } from 'projects/core/src/lib/misc/data/file/file.service';

@Component({
  selector: 'app-check-item-icons',
  templateUrl: './check-item-icons.component.html',
  styleUrls: ['./check-item-icons.component.scss']
})
export class CheckItemIconsComponent implements OnInit, AfterViewInit {

  @Input()
  checkItem: TrelloCheckItem;

  @Input()
  projectId: number;

  @ViewChild('checkItemNfs', {static: true})
  checkItemNfs: OverlayPanel

  @ViewChild('infoIconHover', {static: false})
  infoIconHover: ElementRef

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected dialog: MatDialog,
    protected el: ElementRef,
    private trelloService: TrelloService
  ) {
  }

  ngOnInit(): void {
  }

  openTasks(event, checkItemId: number) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(TasksListDialogComponent, {
      data: {
        entityId: checkItemId,
        clazz: 'CHECKITEM_TASK'
      },
      panelClass: 'tasks-list-dialog',
      disableClose: false
    });
  }

  ngAfterViewInit() {
    if(this.checkItem.toggledBy) {
      const el = (this.el.nativeElement as HTMLElement).getElementsByClassName('hover-info-icon')[0]
      const shtEl = jq(el);

      // tslint:disable-next-line: deprecation
      shtEl.hover(jQEvent => {
        this.showHint(el)
      }, jQEvent => {
        this.hideHint()
      })
    }
  }

  showHint(el: Element) {
    this.checkItemNfs.show({}, el)

    // this.eventHintShowSubs = timer(t).subscribe(() => {
    // 	this.eventHintShown = true;
    // 	this.eventHintOP.show(eventInfo.jsEvent, eventInfo.el.getElementsByClassName('event-shortcode')[0])
    // })
  }

  openFile(event, projectFile: ProjectFile) {
    event.stopPropagation()

    this.fileOpenerService.openFile(projectFile, this.checkItem.files, true)
  }

  hideHint() {
    this.checkItemNfs.hide();
  }
}
